<template>
  <div class="animated fadeIn">
    <b-modal
      centered
      header-class="notification__modal__header"
      :visible="hasRestrictions"
      ok-variant="#277053"
      id="notificationModal"
      title="ATENÇÃO"
      ok-only
    >
      <p>Checar anotações</p>
    </b-modal>
    <RestrictionAlertVue
      v-if="hasRestrictions"
      :hasRestrictions="hasRestrictions"
    />
    <template v-if="objSelected">
      <div class="row">
        <div class="col-md-12">
          <div class="card" style="background-color: #fbfbfb">
            <div class="close-card pb-2">
              <small class="cursor-pointer" @click="onClose"
                >Fechar <i class="far fa-times-circle"></i
              ></small>
            </div>
            <div class="card-block pt-4">
              <!-- HEADER -->
              <input
                type="hidden"
                ref="myCopy"
                id="myCopy"
                name="myCopy"
                value=""
              />
              <div class="form-group row">
                <div class="col-md-6">
                  <b-avatar
                    :class="hasRestrictions ? 'danger-border' : ''"
                    size="4rem"
                    style="float: left; margin-right: 1.5rem; margin-top: 1rem"
                  >
                    <i
                      v-if="objSelected.pessoa.tipoPessoa === 'PF'"
                      style="font-size: 1.5rem"
                      class="far fa-user"
                    ></i>
                    <i
                      v-else
                      style="font-size: 1.5rem"
                      class="far fa-building"
                    ></i>
                  </b-avatar>
                  <div class="cursor-pointer" @click="onCopyName">
                    <strong style="font-size: 23px">{{
                      objSelected ? objSelected.pessoa.nomeAssociado : ''
                    }}</strong>
                    <small
                      ><i
                        class="fas fa-clone"
                        v-b-tooltip.hover
                        title="Clique para copiar"
                      ></i
                    ></small>
                  </div>
                  <span class="input-group w-sm-50">
                    <b-form-input
                      v-model="form.prinome.value"
                      :placeholder="$lang.Common.prinamePlaceholder"
                    />
                  </span>
                  <div style="margin-top: 0.5rem; margin-left: 5.5rem">
                    <div>
                      <i class="fas fa-user"></i>
                      <strong>Tipo Pessoa:</strong>&nbsp;{{
                        objSelected ? objSelected.pessoa.tipoPessoa : ''
                      }}
                    </div>
                    <div class="cursor-pointer" @click="onCopyDocument">
                      <i class="fas fa-id-card"></i> &nbsp;<strong
                        >{{
                          objSelected
                            ? getTipoPessoa(objSelected.pessoa.document) == 'PF'
                              ? 'CPF'
                              : 'CNPJ'
                            : ''
                        }}:&nbsp;</strong
                      >
                      {{
                        objSelected
                          ? onFormatDocument(objSelected.pessoa.document)
                          : ''
                      }}
                      <small
                        ><i
                          class="fas fa-clone"
                          v-b-tooltip.hover
                          title="Clique para copiar"
                        ></i
                      ></small>
                    </div>
                    <div class="cursor-pointer" @click="onCopyNumSisbr">
                      <i class="fas fa-id-card"></i> &nbsp;<strong
                        >Número Sisbr:&nbsp;</strong
                      >
                      {{ objSelected ? objSelected.numSisbr : '' }}
                      <small
                        ><i
                          class="fas fa-clone"
                          v-b-tooltip.hover
                          title="Clique para copiar"
                        ></i
                      ></small>
                    </div>
                    <div
                      v-if="
                        objSelected && objSelected.pessoa.tipoPessoa == 'PJ'
                      "
                    >
                      <i class="fas fa-calendar"></i> &nbsp;<strong
                        >Data de Abertura:&nbsp;</strong
                      >
                      &nbsp;{{
                        objSelected && objSelected.pessoa.dataNascimento
                          ? moment(
                              objSelected.pessoa.dataNascimento.substring(0, 19)
                            ).format('DD/MM/YYYY')
                          : ''
                      }}
                    </div>
                    <div v-else>
                      <i class="fas fa-calendar"></i> &nbsp;<strong
                        >Data de Nascimento:&nbsp;</strong
                      >{{
                        objSelected && objSelected.pessoa.dataNascimento
                          ? moment(
                              objSelected.pessoa.dataNascimento.substring(0, 19)
                            ).format('DD/MM/YYYY')
                          : ''
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 pt-2">
                  <div>
                    <i class="fas fa-users"> &nbsp;</i
                    ><strong>Clusterização:&nbsp;</strong>
                  </div>
                  <span
                    class="input-group"
                    style="margin-top: 0.3rem; margin-bottom: 0.5rem"
                  >
                    <b-form-select
                      v-model="form.clusterizacaoId.value"
                      :options="form.clusterizacaoId.options"
                    >
                      <template slot="first">
                        <option :value="null">
                          {{ $lang.Common.PlaceholderSelect }}
                        </option>
                      </template>
                    </b-form-select>
                  </span>
                  <div>
                    <i class="fas fa-building"></i> &nbsp;<strong
                      >PA:&nbsp;</strong
                    >{{
                      objSelected && objSelected.pa
                        ? objSelected.pa.numero +
                          ' - ' +
                          objSelected.pa.descricao
                        : ''
                    }}
                  </div>
                  <div>
                    <i class="far fa-calendar-check"></i> &nbsp;<strong
                      >Início do Relacionamento:&nbsp;</strong
                    >{{
                      objSelected && objSelected.inicioRelacionamento
                        ? moment(
                            objSelected.inicioRelacionamento.substring(0, 19)
                          ).format('DD/MM/YYYY')
                        : ''
                    }}
                  </div>
                  <div>
                    <i class="fas fa-file-contract"></i> &nbsp;<strong
                      >Última Renovação:&nbsp;</strong
                    >{{
                      objSelected && objSelected.ultimaRenovacao
                        ? moment(
                            objSelected.ultimaRenovacao.substring(0, 19)
                          ).format('DD/MM/YYYY')
                        : ''
                    }}
                  </div>
                </div>
                <div class="col-md-2 pt-2">
                  <div>
                    <i class="fas fa-exclamation-circle"></i>
                    <strong>Possíveis Pendências:</strong>
                    <div class="checkboxFilds ml-4">
                      <b-form-group class="mt-1 mb-0">
                        <b-form-checkbox
                          id="checkboxProtestado"
                          v-model="form.pendencias.notificado.value"
                        >
                          Protestado
                        </b-form-checkbox>
                      </b-form-group>
                      <b-form-group>
                        <b-form-checkbox
                          id="checkboxAjuizado"
                          v-model="form.pendencias.ajuizado.value"
                        >
                          Ajuizado
                        </b-form-checkbox>
                      </b-form-group>
                      <b-form-group>
                        <b-form-checkbox
                          id="checkboxCobranca"
                          :disabled="true"
                          v-model="form.pendencias.cobranca.value"
                        >
                          Cobrança
                        </b-form-checkbox>
                        <b-form-checkbox
                          id="checkboxAbsoluta"
                          :disabled="true"
                          v-model="form.pendencias.impeditivaAbsoluta.value"
                        >
                          Impeditiva Absoluta
                        </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-group row">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-block">
                      <b-avatar class="mr-3 mt-2" style="float: left">
                        <i class="fas fa-user-tie" style="font-size: 18px"></i>
                      </b-avatar>
                      <div>
                        <strong>Gerente SisBR:<br /></strong
                        >{{
                          objSelected && objSelected.gerenteSisBR
                            ? objSelected.gerenteSisBR.pessoa.nome
                            : 'NÃO INFORMADO'
                        }}
                      </div>

                      <div
                        align="center"
                        v-if="
                          objSelected &&
                            objSelected.historicoGerenteSisbr &&
                            objSelected.historicoGerenteSisbr.length > 0
                        "
                      >
                        <b-button
                          v-b-toggle.historicoGerenteSisbrAlteracao
                          class="mt-1"
                          >Mostrar Alterações</b-button
                        >
                        <b-collapse
                          id="historicoGerenteSisbrAlteracao"
                          class="pt-3"
                        >
                          <div>
                            <tables
                              ref="tableGrid"
                              :showHeader="false"
                              :columns="['DATA', 'NOME GERENTE']"
                              :showPaging="false"
                              :showTipFooter="false"
                            >
                              <tr
                                v-for="(alt, index) in objSelected
                                  ? objSelected.historicoGerenteSisbr
                                  : []"
                                :key="index + 'PA'"
                              >
                                <TableColumn
                                  :style="'font-size: 12px'"
                                  :IsText="true"
                                  :status="1"
                                  :value="
                                    alt.dataInicio
                                      ? formatDateTimeForms(alt.dataInicio)
                                      : ''
                                  "
                                />
                                <TableColumn
                                  :style="'font-size: 12px'"
                                  :IsText="true"
                                  :status="1"
                                  :value="alt.funcionario"
                                />
                              </tr>
                            </tables>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-block">
                      <b-avatar class="mr-3 mt-2" style="float: left">
                        <i class="fas fa-user-tie" style="font-size: 18px"></i>
                      </b-avatar>
                      <div>
                        <strong
                          >{{ $lang.RelationchipManager.Label }}:<br
                        /></strong>
                        {{
                          objSelected && objSelected.gerenteRelacionamento
                            ? objSelected.gerenteRelacionamento.pessoa.nome
                            : 'NÃO INFORMADO'
                        }}
                      </div>

                      <div
                        align="center"
                        v-if="
                          objSelected &&
                            objSelected.historicoGerenteRelacionamento &&
                            objSelected.historicoGerenteRelacionamento.length >
                              0
                        "
                      >
                        <b-button
                          v-b-toggle.historicoGerenteRelacionamentoAlteracao
                          class="mt-1"
                          >Mostrar Alterações</b-button
                        >
                        <b-collapse
                          id="historicoGerenteRelacionamentoAlteracao"
                          class="pt-3"
                        >
                          <div>
                            <tables
                              ref="tableGrid"
                              :showHeader="false"
                              :columns="[
                                'DATA DA ALTERAÇÃO',
                                'RESPONSÁVEL',
                                'NOME GERENTE'
                              ]"
                              :showPaging="false"
                              :showTipFooter="false"
                            >
                              <tr
                                v-for="(alt, index) in objSelected
                                  ? objSelected.historicoGerenteRelacionamento
                                  : []"
                                :key="index + 'PA'"
                              >
                                <TableColumn
                                  :style="'font-size: 12px'"
                                  :IsText="true"
                                  :status="1"
                                  :value="
                                    alt.dataInicio
                                      ? formatDateTimeForms(alt.dataInicio)
                                      : ''
                                  "
                                />
                                <TableColumn
                                  :style="'font-size: 12px'"
                                  :IsText="true"
                                  :status="1"
                                  :value="alt.responsavel"
                                />
                                <TableColumn
                                  :style="'font-size: 12px'"
                                  :IsText="true"
                                  :status="1"
                                  :value="alt.funcionario"
                                />
                              </tr>
                            </tables>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-block">
                      <div class="form-group row">
                        <div class="col-md-10">
                          <h5>
                            <strong
                              ><i class="fas fa-map-marker-alt"></i>
                              Logradouro</strong
                            >
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <a
                            v-if="!isBusyLogradouro"
                            href="javascript:void(0);"
                            @click="toggleBusyLogradouro"
                            ><i
                              class="fas fa-eye-slash"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Minimizar Dados'"
                            ></i
                          ></a>
                          <a
                            v-else
                            href="javascript:void(0);"
                            @click="toggleBusyLogradouro"
                            ><i
                              class="fas fa-eye"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Mostrar Dados'"
                            ></i
                          ></a>
                        </div>
                      </div>
                      <div v-if="!isBusyLogradouro">
                        <div v-if="address && address.length > 0">
                          <b-tabs content-class="mt-3" pills card>
                            <b-tab
                              v-for="(obj, index) in address"
                              :key="index"
                              :title="(index + 1).toString()"
                            >
                              <div class="form-group row">
                                <div class="col-md-12">
                                  <label><strong>Endereço</strong></label>
                                  <div class="input-group">
                                    {{ obj.logradouro }}
                                  </div>
                                </div>
                              </div>
                              <div class="form-group row pt-2">
                                <div class="col-md-6">
                                  <label><strong>Complemento</strong></label>
                                  <div class="input-group">
                                    {{ obj.complemento }}
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <label><strong>Número</strong></label>
                                  <div class="input-group">
                                    {{ obj.numero }}
                                  </div>
                                </div>
                              </div>
                              <div class="form-group row pt-2">
                                <div class="col-md-6">
                                  <label><strong>Bairro</strong></label>
                                  <div class="input-group">
                                    {{ obj.bairro }}
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <label><strong>Cep</strong></label>
                                  <div class="input-group">
                                    {{ formatCep(obj.cep) }}
                                  </div>
                                </div>
                              </div>
                              <div class="form-group row pt-2">
                                <div class="col-md-6">
                                  <label><strong>Cidade</strong></label>
                                  <div class="input-group">
                                    {{ obj.municipio }}
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <label><strong>UF</strong></label>
                                  <div class="input-group">{{ obj.uf }}</div>
                                </div>
                              </div>
                              <div class="form-group row pt-2">
                                <div class="col-md-12">
                                  <label
                                    ><strong
                                      >Endereço de correspondência</strong
                                    ></label
                                  >
                                  <div class="input-group">
                                    {{ obj.endereco }}
                                  </div>
                                </div>
                              </div>
                            </b-tab>
                          </b-tabs>
                        </div>
                        <div v-else>
                          <div class="form-group row pt-3">
                            <div class="col-md-12">
                              <label><strong>Endereço</strong></label>
                              <div class="input-group"></div>
                            </div>
                          </div>
                          <div class="form-group row pt-2">
                            <div class="col-md-6">
                              <label><strong>Complemento</strong></label>
                              <div class="input-group"></div>
                            </div>
                            <div class="col-md-6">
                              <label><strong>Número</strong></label>
                              <div class="input-group"></div>
                            </div>
                          </div>
                          <div class="form-group row pt-2">
                            <div class="col-md-12">
                              <label><strong>Bairro</strong></label>
                              <div class="input-group"></div>
                            </div>
                          </div>
                          <div class="form-group row pt-2">
                            <div class="col-md-6">
                              <label><strong>Cidade</strong></label>
                              <div class="input-group"></div>
                            </div>
                            <div class="col-md-6">
                              <label><strong>UF</strong></label>
                              <div class="input-group"></div>
                            </div>
                          </div>
                          <div class="form-group row pt-2">
                            <div class="col-md-12">
                              <label
                                ><strong
                                  >Endereço de correspondência</strong
                                ></label
                              >
                              <div class="input-group"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-block">
                      <div class="form-group row">
                        <div class="col-md-10 pb-2">
                          <h5>
                            <strong
                              ><i class="fas fa-address-book"></i>
                              Contatos</strong
                            >
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <a
                            v-if="!isBusyContato"
                            href="javascript:void(0);"
                            @click="toggleBusyContato"
                            ><i
                              class="fas fa-eye-slash"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Minimizar Dados'"
                            ></i
                          ></a>
                          <a
                            v-else
                            href="javascript:void(0);"
                            @click="toggleBusyContato"
                            ><i
                              class="fas fa-eye"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Mostrar Dados'"
                            ></i
                          ></a>
                        </div>
                        <div
                          class="table-responsive pt-2 pl-4 pr-4"
                          v-if="phones && !isBusyContato"
                        >
                          <table
                            class="table table-hover"
                            style="border: 1px solid #dcdede"
                          >
                            <thead
                              class="thead-third"
                              style="border: solid 1px #04a791; font-size: 12px"
                            >
                              <tr>
                                <th class="text-center">CONTATO</th>
                                <th class="text-center">TIPO</th>
                                <th class="text-center">AÇÕES</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(obj, index) in phones" :key="index">
                                <td class="text-center" style="padding: 8px">
                                  <a :href="`tel:${obj.telefone}`">{{
                                    obj.telefone
                                  }}</a>
                                </td>
                                <td
                                  class="text-center"
                                  style="font-size: 11px; padding: 8px"
                                >
                                  {{ obj.tipoContato }}
                                </td>
                                <td
                                  @click="openShowMessages(objSelected, obj.telefone)"
                                  class="text-center"
                                  style="
                                    font-size: 14px;
                                    cursor: pointer;
                                    padding: 8px;
                                  "
                                >
                                  <i
                                    :class="
                                      obj.tipoContato === 'CELULAR'
                                        ? 'fab fa-whatsapp'
                                        : 'fas fa-phone-alt'
                                    "
                                  ></i>
                                </td>
                              </tr>
                              <tr v-if="mail">
                                <td class="text-center" style="padding: 8px">
                                  <a :href="`mailto:${mail}`">{{ mail }}</a>
                                </td>
                                <td
                                  class="text-center"
                                  style="font-size: 11px; padding: 8px"
                                >
                                  E-MAIL
                                </td>
                                <td
                                  @click="toastInfo"
                                  class="text-center"
                                  style="
                                    font-size: 14px;
                                    cursor: pointer;
                                    padding: 8px;
                                  "
                                >
                                  <i class="fas fa-mail-bulk"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-block">
                      <div class="form-group row">
                        <div class="col-md-10 pb-2">
                          <h5>
                            <strong
                              ><i class="fas fa-users"></i> Relacionamento
                            </strong>
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <a
                            v-if="!isBusyRelacionamento"
                            href="javascript:void(0);"
                            @click="toggleBusyRelacionamento"
                            ><i
                              class="fas fa-eye-slash"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Minimizar Dados'"
                            ></i
                          ></a>
                          <a
                            v-else
                            href="javascript:void(0);"
                            @click="toggleBusyRelacionamento"
                            ><i
                              class="fas fa-eye"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Mostrar Dados'"
                            ></i
                          ></a>
                        </div>
                        <div
                          class="table-responsive pt-2 pl-4 pr-4"
                          v-if="phones && !isBusyRelacionamento"
                        >
                          <table
                            class="table table-hover"
                            style="border: 1px solid #dcdede"
                          >
                            <thead
                              class="thead-third"
                              style="border: solid 1px #04a791; font-size: 12px"
                            >
                              <tr>
                                <th class="text-center">DOCUMENTO</th>
                                <th class="text-center">NOME</th>
                                <th class="text-center">TIPO PESSOA</th>
                                <th class="text-center">DESCRIÇÃO</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                style="font-size: 11px"
                                v-for="(obj, index) in personRelations"
                                :key="index"
                              >
                                <TableColumn
                                  :IsText="true"
                                  :status="1"
                                  :value="obj.documentoPessoaRelacionada"
                                  @Edit="
                                    openAssociatePageByRelacionamento(
                                      obj.documentoPessoaRelacionada
                                    )
                                  "
                                />
                                <TableColumn
                                  :IsText="true"
                                  :status="1"
                                  :value="obj.nomePessoaRelacionada"
                                  @Edit="
                                    openAssociatePageByRelacionamento(
                                      obj.documentoPessoaRelacionada
                                    )
                                  "
                                />
                                <TableColumn
                                  :IsText="true"
                                  :status="1"
                                  :value="obj.tipopessoaRelacionada"
                                  @Edit="
                                    openAssociatePageByRelacionamento(
                                      obj.documentoPessoaRelacionada
                                    )
                                  "
                                />
                                <TableColumn
                                  :IsText="true"
                                  :status="1"
                                  :value="obj.descricaoPessoaRelacionada"
                                  @Edit="
                                    openAssociatePageByRelacionamento(
                                      obj.documentoPessoaRelacionada
                                    )
                                  "
                                />
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-block">
                      <div class="form-group row">
                        <div class="col-md-10 pb-2">
                          <h5>
                            <strong
                              ><i class="fas fa-users"></i> Pessoas no Grupo
                              Econômico
                            </strong>
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <a
                            v-if="!isBusyGrupoEconomico"
                            href="javascript:void(0);"
                            @click="toggleBusyGrupoEconomico"
                            ><i
                              class="fas fa-eye-slash"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Minimizar Dados'"
                            ></i
                          ></a>
                          <a
                            v-else
                            href="javascript:void(0);"
                            @click="toggleBusyGrupoEconomico"
                            ><i
                              class="fas fa-eye"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Mostrar Dados'"
                            ></i
                          ></a>
                        </div>
                        <div
                          class="table-responsive pt-2 pl-3 pr-3"
                          v-show="!isBusyGrupoEconomico"
                        >
                          <table
                            class="table table-hover"
                            style="border: 1px solid #dcdede"
                          >
                            <thead
                              class="thead-third"
                              style="border: solid 1px #04a791; font-size: 12px"
                            >
                              <tr>
                                <th class="text-center">NOME</th>
                                <th class="text-center">GRUPO ECONÔMICO</th>
                                <th class="text-center">
                                  CÓD. GRUPO ECONÔMICO
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                style="font-size: 11px"
                                v-for="(obj, index) in pessoaGrupoEconomicoList"
                                :key="index"
                              >
                                <TableColumn
                                  :IsText="true"
                                  :status="1"
                                  :value="obj.nomeCliente"
                                  @Edit="openAssociatePage(obj.associadoId)"
                                />
                                <TableColumn
                                  :IsText="true"
                                  :status="1"
                                  :value="obj.descricaoGrupoEconomico"
                                  @Edit="openAssociatePage(obj.associadoId)"
                                />
                                <TableColumn
                                  :IsText="true"
                                  :status="1"
                                  :value="obj.codigoGrupoEconomico.toString()"
                                  @Edit="openAssociatePage(obj.associadoId)"
                                />
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    v-if="objSelected && objSelected.pessoa.tipoPessoa == 'PF'"
                    class="card"
                  >
                    <div class="card-block">
                      <div class="form-group row">
                        <div class="col-md-12 pb-2">
                          <h5>
                            <strong
                              ><i class="far fa-user"></i> Informações
                              Pessoais</strong
                            >
                          </h5>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-md-8">
                          <div class="input-group">
                            <strong>DOCUMENTO DE IDENTIFICAÇÃO:&nbsp;</strong
                            >{{
                              objSelected
                                ? objSelected.pessoa.numeroDocumentoIdentidade
                                : ''
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-md-6">
                          <div class="input-group">
                            <strong>UF: &nbsp;</strong
                            >{{
                              objSelected
                                ? objSelected.pessoa.siglaUFOrgaoExpeditor
                                : ''
                            }}
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="input-group">
                            <strong>Sexo:&nbsp;</strong
                            >{{
                              objSelected && objSelected.pessoa.sexo == 'F'
                                ? 'Feminino'
                                : 'Masculino'
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-md-6">
                          <div class="input-group">
                            <strong>Orgão emissor:&nbsp;</strong
                            >{{
                              objSelected
                                ? objSelected.pessoa.descricaoOrgaoExpeditor
                                : ''
                            }}
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="input-group">
                            <strong>Naturalidade:&nbsp;</strong
                            >{{
                              objSelected ? objSelected.pessoa.naturalidade : ''
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-md-6">
                          <div class="input-group">
                            <strong>Estado civil:&nbsp;</strong
                            >{{
                              objSelected ? objSelected.pessoa.estadoCivil : ''
                            }}
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="input-group">
                            <strong>Escolaridade: &nbsp;</strong
                            >{{
                              objSelected ? objSelected.pessoa.escolaridade : ''
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-block">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <h5>
                            <strong
                              ><i class="fa fa-university"></i> Informações de
                              Contas</strong
                            >
                          </h5>
                        </div>
                      </div>
                      <div
                        v-for="contaCorrente in contaCorrenteList"
                        v-bind:key="contaCorrente.id + 'ccorr'"
                      >
                        <strong>Conta Corrente: </strong
                        >{{
                          contaCorrente ? contaCorrente.numeroContaCorrente : ''
                        }}
                        <strong>- Status:</strong>
                        {{
                          contaCorrente
                            ? contaCorrente.situacaoContaCorrente
                            : ''
                        }}
                      </div>
                      <div
                        v-for="contaCapital in contaCapitalList"
                        v-bind:key="contaCapital.id + 'ccap'"
                      >
                        <strong>Conta Capital: </strong
                        >{{ contaCapital ? contaCapital.numContaCapital : '' }}
                        <strong>- Status:</strong>
                        {{
                          contaCapital ? contaCapital.situacaoContaCapital : ''
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="card cardScroll">
                    <div class="card-block">
                      <div class="form-group row">
                        <div class="col-md-10">
                          <h5>
                            <strong
                              ><i class="fas fa-landmark"></i> Resumo Operações
                              Financeiras</strong
                            >
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <a
                            v-if="!isBusyInfosFinance"
                            href="javascript:void(0);"
                            @click="isBusyInfosFinance = !isBusyInfosFinance"
                            ><i
                              class="fas fa-eye-slash"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Minimizar Dados'"
                            ></i
                          ></a>
                          <a
                            v-else
                            href="javascript:void(0);"
                            @click="onLoadFinanceResume"
                            ><i
                              class="fas fa-eye"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Mostrar Dados'"
                            ></i
                          ></a>
                        </div>
                      </div>
                      <!-- BEGIN CARD -->
                      <div v-if="!isBusyInfosFinance">
                        <div class="associate__info__rows__container">
                          <div class="d-flex justify-content-end">
                            <b-button v-b-toggle.collapse-1 class="btn btn-third btn-sm">Filtrar <i class="fas fa-filter"></i></b-button>
                          </div>
                          <b-collapse id="collapse-1" class="mt-2">
                            <div class="card shadow-sm p-3">
                              <br />
                              <label>Modalidade Produto</label>
                              <v-select
                                :options="productOptions"
                                label="text"
                                class="w-100"
                                v-model="productSelected"
                                placeholder="Selecione uma Modalidade Produto"
                              ></v-select>
                              <br />
                              <label>Modalidade Bacen</label>
                              <v-select
                                :options="bacenOptions"
                                taggable
                                label="text"
                                class="w-100"
                                v-model="bacenSelected"
                                placeholder="Selecione uma Modalidade Bacen"
                              ></v-select>
                              <br />
                              <label>Modalidade Sub Bacen</label>
                              <v-select
                                :options="subBacenOptions"
                                taggable
                                label="text"
                                class="w-100"
                                v-model="subBacenSelected"
                                placeholder="Selecione uma Modalidade Sub Bacen"
                              ></v-select>
                              <br />
                            </div>
                          </b-collapse>
                          <div v-if="financeResume.contracts.length">
                            <b-card class="mt-2 shadow-sm" no-body>
                              <b-tabs
                                pills
                                class="tabsScroll"
                                content-class="mt-3"
                              >
                                <b-tab
                                  v-for="(c, index) in financeResume.contracts"
                                  v-bind:key="index"
                                >
                                <template slot="title">
                                    <span class="mr-auto">{{ index + 1 }}º</span>
                                </template>

                                  <div class="associate__info__rows__group">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h3
                                        class="associate__info__rows__group__title"
                                      >
                                        Contratos Vigentes
                                      </h3>
                                      <div class="">
                                        <b-button v-b-toggle.collapse-1 class="btn btn-third btn-sm" @click="handleShowVigentes" v-if="maiorQueDezContratos">
                                          Ver mais
                                        </b-button>
                                      </div>
                                    </div>
                                    <div class="position-tag">
                                      <span
                                        v-if="productSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ productSelected }}
                                        <button
                                          class="remove-button"
                                          @click="productSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                      <span
                                        v-if="bacenSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ bacenSelected }}
                                        <button
                                          class="remove-button"
                                          @click="bacenSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                      <span
                                        v-if="subBacenSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ subBacenSelected }}
                                        <button
                                          class="remove-button"
                                          @click="subBacenSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                    </div>

                                    <div class="row__container">
                                      <p class="row__type">
                                        Número Do Contrato De Crédito
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.numeroContrato
                                            ? c.numeroContrato
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">Valor Do Contrato</p>
                                      <p class="row__description">
                                        {{
                                          c.valorContrato ||
                                          c.valorContrato === 0
                                            ? onFormatMoney(c.valorContrato)
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">
                                        Valor Saldo Devedor Diário
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.vlrSaldoDevedorDiario ||
                                          c.vlrSaldoDevedorDiario === 0
                                            ? onFormatMoney(
                                                c.vlrSaldoDevedorDiario
                                              )
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">Modalidade Bacen</p>
                                      <p class="row__description">
                                        {{
                                          c.modalidadeBacen
                                            ? c.modalidadeBacen.toLowerCase()
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">
                                        Modalidade Produto
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.modalidadeProduto
                                            ? c.modalidadeProduto.toLowerCase()
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">
                                        Modalidade Sub Bacen
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.submodalidadeBacen
                                            ? c.submodalidadeBacen.toLowerCase()
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </b-tab>
                              </b-tabs>
                            </b-card>
                          </div>

                          <div>
                            <b-card class="shadow-sm" no-body>
                              <b-tabs class="tabsScroll" pills>
                                <b-tab
                                  v-for="(c, index) in financeResume.accounts"
                                  v-bind:key="index"
                                >
                                  <template slot="title">
                                    {{ index + 1 }}ª
                                  </template>
                                  <div class="associate__info__rows__group">
                                    <h3
                                      class="associate__info__rows__group__title"
                                    >
                                      Conta Corrente
                                    </h3>
                                    <div class="position-tag">
                                      <span
                                        v-if="productSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ productSelected }}
                                        <button
                                          class="remove-button"
                                          @click="productSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                      <span
                                        v-if="bacenSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ bacenSelected }}
                                        <button
                                          class="remove-button"
                                          @click="bacenSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                      <span
                                        v-if="subBacenSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ subBacenSelected }}
                                        <button
                                          class="remove-button"
                                          @click="subBacenSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                    </div>

                                    <div class="row__container">
                                      <p class="row__type">
                                        Número da Conta Corrente
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.numeroContaCorrente
                                            ? c.numeroContaCorrente.toLowerCase()
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">Situação</p>
                                      <p class="row__description">
                                        {{
                                          c.situacaoContaCorrente
                                            ? c.situacaoContaCorrente.toLowerCase()
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">
                                        Valor Saldo Depósito
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.valorSaldoDepositoContaCorrente ||
                                          c.valorSaldoDepositoContaCorrente ===
                                            0
                                            ? onFormatMoney(
                                                c.valorSaldoDepositoContaCorrente
                                              )
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">
                                        Valor Saldo Bloqueio Judicial
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.valorSaldoBloqueioJudicial ||
                                          c.valorSaldoBloqueioJudicial === 0
                                            ? onFormatMoney(
                                                c.valorSaldoBloqueioJudicial
                                              )
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">
                                        Valor Saldo Devedor ADP
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.valorSaldoDevedorADP ||
                                          c.valorSaldoDevedorADP === 0
                                            ? onFormatMoney(
                                                c.valorSaldoDevedorADP
                                              )
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">
                                        Valor Saldo Devedor Limite Crédito
                                      </p>
                                      <p class="row__description">
                                        {{
                                          c.valorSaldoDevedorLimiteCredito
                                            ? onFormatMoney(
                                                c.valorSaldoDevedorLimiteCredito
                                              )
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </b-tab>
                              </b-tabs>
                            </b-card>
                          </div>

                          <div v-if="financeResume.cobrancaProducts.length">
                            <b-card class="shadow-sm" no-body>
                              <b-tabs class="tabsScroll" pills>
                                <b-tab
                                  v-for="(c,
                                  index) in financeResume.cobrancaProducts"
                                  v-bind:key="index"
                                >
                                  <template slot="title">
                                    {{ index + 1 }}ª
                                  </template>
                                  <div class="associate__info__rows__group">
                                    <h3
                                      class="associate__info__rows__group__title"
                                    >
                                      Cobrança
                                    </h3>
                                    <div class="position-tag">
                                      <span
                                        v-if="productSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ productSelected }}
                                        <button
                                          class="remove-button"
                                          @click="productSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                      <span
                                        v-if="bacenSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ bacenSelected }}
                                        <button
                                          class="remove-button"
                                          @click="bacenSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                      <span
                                        v-if="subBacenSelected"
                                        class="tag"
                                        style="font-size: 10px;"
                                      >
                                        {{ subBacenSelected }}
                                        <button
                                          class="remove-button"
                                          @click="subBacenSelected = null"
                                        >
                                          &times;
                                        </button>
                                      </span>
                                    </div>

                                    <div class="row__container">
                                      <p class="row__type">Produto</p>
                                      <p class="row__description">
                                        {{
                                          c.produtoDTO.nome
                                            ? c.produtoDTO.nome.toLowerCase()
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">Operação</p>
                                      <p class="row__description">
                                        {{ c.operacao ? c.operacao : '-' }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">Dias Em Atraso</p>
                                      <p class="row__description">
                                        {{ c.diasAtraso ? c.diasAtraso : '-' }}
                                      </p>
                                    </div>
                                    <div class="row__container">
                                      <p class="row__type">Valor</p>
                                      <p class="row__description">
                                        {{
                                          c.valor || c.valor === 0
                                            ? onFormatMoney(c.valor)
                                            : '-'
                                        }}
                                      </p>
                                    </div>
                                    <DefaultButton
                                      btnVariant="btn-third justify-content-center"
                                      :onClick="() => openCard(c.cardDTO.id)"
                                      text="Ver Card"
                                    />
                                  </div>
                                </b-tab>
                              </b-tabs>
                            </b-card>
                          </div>
                          <div v-if="financeResume.cards.ajuizamento.length">
                            <div class="associate__info__rows__group">
                              <h3 class="associate__info__rows__group__title">
                                Oportunidades em Ajuizamento
                              </h3>
                              <DefaultButton
                                v-for="(c, index) in financeResume.cards
                                  .ajuizamento"
                                v-bind:key="index"
                                btnVariant="btn-third justify-content-center"
                                :onClick="() => openCard(c.id)"
                                text="Ver Card"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- END CARD -->
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-block pb-5">
                      <div class="form-group row">
                        <div class="col-md-10">
                          <h5>
                            <strong
                              ><i class="far fa-user"></i> Informações do
                              Associado</strong
                            >
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <a
                            v-if="!isBusyInfosAssociado"
                            href="javascript:void(0);"
                            @click="toggleBusyInfosAssociado"
                            ><i
                              class="fas fa-eye-slash"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Minimizar Dados'"
                            ></i
                          ></a>
                          <a
                            v-else
                            href="javascript:void(0);"
                            @click="toggleBusyInfosAssociado"
                            ><i
                              class="fas fa-eye"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Mostrar Dados'"
                            ></i
                          ></a>
                        </div>
                      </div>
                      <!-- BEGIN CARD -->
                      <div v-if="!isBusyInfosAssociado">
                        <div class="associate__info__rows__container">
                          <div
                            class="row__container"
                            style="justify-content: flex-start; gap: 1.5rem"
                          >
                            <div class="row__item">
                              <i
                                :class="
                                  'fas ' +
                                    (objSelected &&
                                    checkTrueReturnBoolean(
                                      objSelected.indicadorProdutorRural,
                                      'indicadorProdutorRural'
                                    )
                                      ? 'fa-check-circle'
                                      : 'fa-times-circle')
                                "
                              ></i>
                              <p class="row__type">Produtor Rural</p>
                            </div>
                            <div class="row__item">
                              <i
                                :class="
                                  'fas ' +
                                    (objSelected &&
                                    checkTrueReturnBoolean(
                                      objSelected.mei,
                                      'mei'
                                    )
                                      ? 'fa-check-circle'
                                      : 'fa-times-circle')
                                "
                              ></i>
                              <p class="row__type">MEI</p>
                            </div>
                            <div class="row__item">
                              <i
                                :class="
                                  'fas ' +
                                    (objSelected &&
                                    checkTrueReturnBoolean(
                                      indicadorPep,
                                      'indicadorPep'
                                    )
                                      ? 'fa-check-circle'
                                      : 'fa-times-circle')
                                "
                              ></i>
                              <p class="row__type">PEP</p>
                            </div>
                          </div>
                          <div class="row__container">
                            <p class="row__type">Vínculo Empregatício</p>
                            <p class="row__description">
                              {{
                                objSelected.vinculoEmpregaticio
                                  ? objSelected.vinculoEmpregaticio.toLowerCase()
                                  : '-'
                              }}
                            </p>
                          </div>
                          <div class="row__container">
                            <p class="row__type">Descrição da Profissão</p>
                            <p class="row__description">
                              {{
                                objSelected.descricaoProfissao
                                  ? objSelected.descricaoProfissao.toLowerCase()
                                  : '-'
                              }}
                            </p>
                          </div>
                          <div class="row__container">
                            <p class="row__type">Atividade Econômica</p>
                            <p class="row__description">
                              {{
                                objSelected.atividadeEconomica
                                  ? objSelected.atividadeEconomica.toLowerCase()
                                  : '-'
                              }}
                            </p>
                          </div>
                          <div class="row__container">
                            <p class="row__type">Risco PLD</p>
                            <p class="row__description">
                              {{
                                nivelRiscoPld
                                  ? nivelRiscoPld.toLowerCase()
                                  : '-'
                              }}
                            </p>
                          </div>
                          <div class="row__container">
                            <p class="row__type">Descrição da Categoria</p>
                            <div class="row__item">
                              <p
                                class="row__description"
                                v-for="descCat in objSelected.descricaoCategoria
                                  ? filterArray(objSelected.descricaoCategoria)
                                  : ['-']"
                                v-bind:key="descCat"
                              >
                                {{ descCat }}
                              </p>
                            </div>
                          </div>
                          <div
                            v-if="
                              checkTrueReturnBoolean(
                                objSelected.indicadorProdutorRural,
                                'indicadorProdutorRural'
                              )
                            "
                            class="row__container"
                          >
                            <p class="row__type">
                              Descrição da Categoria Produtor Rural
                            </p>
                            <p class="row__description">
                              {{
                                objSelected.descricaoCategoriaProdutorRural
                                  ? objSelected.descricaoCategoriaProdutorRural.toLowerCase()
                                  : '-'
                              }}
                            </p>
                          </div>
                          <div class="row__container" style="border: none">
                            <p class="row__type">CNAE</p>
                            <p class="row__description">
                              {{
                                objSelected.codigoCnae
                                  ? objSelected.codigoCnae
                                  : ''
                              }}
                              <span style="font-weight: 500">
                                -
                                {{
                                  objSelected.cnae
                                    ? objSelected.cnae.toLowerCase()
                                    : ''
                                }}</span
                              >
                            </p>
                          </div>
                          <div
                            class="row__container"
                            style="
                              border-bottom: none;
                              border-top: solid 1px #d9d9d9;
                              margin-top: 4rem;
                            "
                          >
                            <div class="row__item">
                              <p class="row__type">Tipo de Renda:</p>
                              <p class="row__description">
                                {{
                                  objSelected.tipoRenda
                                    ? objSelected.tipoRenda.toLowerCase()
                                    : '-'
                                }}
                              </p>
                            </div>
                            <div class="row__item">
                              <div class="row__item">
                                <i
                                  @click="toggleMoneyBlur"
                                  :class="
                                    'fas ' +
                                      (moneyBlur ? 'fa-eye' : 'fa-eye-slash')
                                  "
                                  style="cursor: pointer"
                                ></i>
                                <span
                                  class="row__description"
                                  style="font-size: 1rem"
                                  >R$
                                  <p
                                    :class="moneyBlur ? 'money__blur' : ''"
                                    style="display: inline-block"
                                  >
                                    {{
                                      grossMonthlyIncome
                                        ? grossMonthlyIncome
                                        : '-'
                                    }}
                                  </p></span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-md-12">
                            <label><strong>Observações</strong></label>
                            <div class="input-group">
                              <b-form-textarea
                                v-model="form.observacao.value"
                                :placeholder="'Observações gerais do Associado'"
                                :rows="form.observacao.rows"
                                :size="form.observacao.maxlength"
                                :noResize="form.observacao.noResize"
                              >
                              </b-form-textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- END CARD -->
                    </div>
                  </div>
                  <div v-if="(hasRole('OPERADOR_ATENDIMENTO') || hasRole('OPERADOR_ATENDIMENTO_GERAL') || hasRole('GESTOR_ATENDIMENTO'))
                   && allConversations.length != []" class="card">
                    <div class="card-block">
                      <div class="form-group row">
                        <div class="col-md-10">
                          <h5>
                            <strong
                              ><i class="fas fa-headset"></i> Atendimentos</strong
                            >
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <a
                            v-if="!isAtendimento"
                            href="javascript:void(0);"
                            @click="toggleAtendimento"
                            ><i
                              class="fas fa-eye-slash"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Minimizar Dados'"
                            ></i
                          ></a>
                          <a
                            v-else
                            href="javascript:void(0);"
                            @click="toggleAtendimento"
                            ><i
                              class="fas fa-eye"
                              style="font-size: 16px"
                              v-b-tooltip.hover
                              :title="'Mostrar Dados'"
                            ></i
                          ></a>
                        </div>
                      </div>
                      <div>
                      </div>
                      <div
                      v-if="!isAtendimento && personTelefone != null"
                      >
                        <Protocols :person="personTelefone"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="form-group row pt-2 pb-2">
                <div class="col-md-12 text-right">
                  <button
                    type="button"
                    class="btn btn-third btn-sm"
                    v-b-tooltip.hover
                    :title="$lang.Common.Tooltip.ButtonBack"
                    @click="onClose"
                  >
                    <i class="fas fa-undo"></i>
                    <span class="d-md-down-none">{{
                      $lang.Common.Buttons.Back
                    }}</span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-third btn-sm"
                    v-b-tooltip.hover
                    :title="$lang.Common.Tooltip.ButtonSave"
                    @click="onUpdate"
                  >
                    <i class="fa fa-check-circle"></i>
                    <span class="d-md-down-none">{{
                      $lang.Common.Buttons.Save
                    }}</span></button
                  >&nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalCard
          ref="ModalCard"
          v-if="selectedCard"
          :boardColumns="[]"
          @hideModal="closeCard"
          v-bind:key="selectedCard"
          :cardId="selectedCard"
        />
      <AssociateCreate
        class="pos"
        ref="newConversationModal"
        :conversationInfo="conversationAssociate"
      />
      </div>
    </template>

    <AssociateDetailsTabs v-show="objSelected" ref="AssociateDetailsTabs" id="associateDetailsTabs"/>
  </div>
</template>
<script>
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import RestrictionAlertVue from '@/components/UI/restrictionAlert/restrictionAlert'
import Tools from '@/components/tools/Tools.js'
import boardTypes from '@/enums/enumBoardTypes.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import AssociateDetailsTabs from '@/views/private/associate/components/associatedetailsTabs.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import 'vue-select/dist/vue-select.css'

import ContaCorrenteRepository from '@/shared/http/repositories/business/contacorrente.js'
import ContratosVigentesRepository from '@/shared/http/repositories/business/contratosvigentes.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'
// import ContaCorrente from '@/shared/http/repositories/business/averagebalancecco.js'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import ContaCapital from '@/shared/http/repositories/business/capitalaccount.js'
import EconomicGroupRepository from '@/shared/http/repositories/business/economicgroup.js'
import PatrimonyRepository from '@/shared/http/repositories/business/patrimony.js'
import PldRepository from '@/shared/http/repositories/business/pld.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster.js'
import FuncionarioRepository from '@/shared/http/repositories/configurations/employee.js'
import PARepository from '@/shared/http/repositories/configurations/pa'
import Protocols from '@/views/private/atendimento/components/protocols/Protocols.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'

import TabPessoasGrupoEconomico from '@/views/private/associate/tabs/pessoasgrupoeconomico.vue'
import AssociateCreate from './associateCreate.vue'

const formDetail = {
  observacao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '4',
    noResize: true
  },
  clusterizacaoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  gerenteRelacionamento: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  prinome: {
    value: null,
    required: false,
    state: null
  },
  pendencias: {
    ajuizado: {
      value: null,
      required: false,
      state: null
    },
    notificado: {
      value: null,
      required: false,
      state: null
    },
    cobranca: {
      value: null,
      required: false,
      state: null
    },
    impeditivaAbsoluta: {
      value: null,
      required: false,
      state: null
    }
  }
}

export default {
  name: 'AssociateDetails',
  mixins: [ActionsForm],
  data () {
    return {
      form: formDetail,
      boardTypes: boardTypes,
      financeResume: {},
      objSelected: null,
      selectedCard: null,
      screenW: screen.width,
      patrimony: null,
      nivelRiscoPld: null,
      indicadorPep: null,
      contaCorrenteList: [],
      contaCapitalList: [],
      conversationAssociate: [],
      showConversation: false,
      paGerenteRelacionamento: [],
      pessoaGrupoEconomicoList: [],
      paGerenteSisbr: [],
      productOptions: [],
      productSelected: null,
      bacenOptions: [],
      bacenSelected: null,
      subBacenOptions: [],
      subBacenSelected: null,
      hasRestrictions: false,
      isBusyInfosAssociado: true,
      isBusyInfosFinance: true,
      isBusyGrupoEconomico: true,
      isBusyContato: true,
      isBusyLogradouro: true,
      isBusyRelacionamento: true,
      isAtendimento: true,
      messages: [],
      moneyBlur: true,
      maiorQueDezContratos: false,
      hasAtendimento: process.env.hasAtendimento,
      allConversations: [],
      personTelefone: null
    }
  },
  components: {
    TabPessoasGrupoEconomico,
    RestrictionAlertVue,
    AssociateDetailsTabs,
    DefaultButton,
    ModalCard,
    AssociateCreate,
    Protocols
  },
  async mounted () {
    await this.onLoadAssociado(this.associateId)
    await this.onLoadAllCluster()
    await this.onLoadAllFuncionarios()
  },
  watch: {
    productSelected: {
      handler: function (newValue) {
        this.onLoadContratosVigentesRepository(this.document, newValue)
      }
    },
    bacenSelected: {
      handler: function (newValue) {
        this.onLoadContratosVigentesRepository(
          this.document,
          this.productSelected,
          newValue
        )
      }
    },
    subBacenSelected: {
      handler: function (newValue) {
        this.onLoadContratosVigentesRepository(
          this.document,
          this.productSelected,
          this.bacenSelected,
          newValue
        )
      }
    }
  },
  computed: {
    grossMonthlyIncome () {
      let result = 'R$ 0,00'
      if (this.objSelected) {
        result = Tools.formatMoneyBR(this.objSelected.rendaBrutaMensal)
      }
      return result.replace(/^R\$ /, '')
    },
    address () {
      let result = null
      if (this.objSelected && this.objSelected.pessoa.endereco) {
        result = this.objSelected.pessoa.endereco
      }
      return result
    },
    phones () {
      let result = null
      if (this.objSelected && this.objSelected.pessoa.telefone) {
        result = this.objSelected.pessoa.telefone
      }
      return result
    },
    mail () {
      let result = null
      if (this.objSelected && this.objSelected.pessoa.email) {
        result = this.objSelected.pessoa.email
      }
      return result
    },
    personRelations () {
      let result = null
      if (this.objSelected && this.objSelected.pessoaRelacionada) {
        result = this.objSelected.pessoaRelacionada
      }
      return result
    },
    initialName: function () {
      let result = ''
      if (this.objSelected && this.objSelected.nome) {
        var names = this.objSelected.nome.split(' ')
        if (names && names.length > 1) {
          result =
              names[0].substring(0, 1) + names[names.length - 1].substring(0, 1)
        } else if (names && names.length > 0) {
          result = names[0].substring(0, 1)
        }
      }
      return result
    },
    personTypeByDocument: function () {
      let result = 'PF'
      if (this.objSelected && this.objSelected.document) {
        let doc = this.objSelected.document.replace('.', '')
        doc = doc.replace('.', '')
        doc = doc.replace('-', '')
        doc = doc.replace('/', '')

        if (doc.length > 11) {
          result = 'PJ'
        }
      }
      return result
    },
    associateId () {
      return this.$route.params.associateId
    },
    backUrl: function () {
      return 'Associate'
    }
  },
  methods: {
    async onLoadAssociado (id) {
      try {
        loading.push()

        this.form.clusterizacaoId.value = null
        this.form.observacao.value = ''
        this.form.gerenteRelacionamento.value = null
        this.form.prinome.value = null
        this.form.pendencias.notificado.value = false
        this.form.pendencias.ajuizado.value = false
        this.form.pendencias.cobranca.value = false
        this.form.pendencias.impeditivaAbsoluta.value = false

        const response = await AssociateRepository.GetById(id)

        if (!response || !response.data) return

        const data = response.data
        this.objSelected = data
        this.checkPendencias(data)

        this.$refs.AssociateDetailsTabs.objSelected = data
        this.$refs.AssociateDetailsTabs.onCallDependences(
          data.pessoa.document
        )

        this.onCallDependences(data.pessoa.document)

        this.form.clusterizacaoId.value = data.clusterizacaoDTO
          ? data.clusterizacaoDTO.id
          : null
        this.form.observacao.value = data.observacao ? data.observacao : null
        this.form.prinome.value = data.pessoa.prinome
          ? data.pessoa.prinome
          : null
        this.form.pendencias.notificado.value = data.pendencias
          ? data.pendencias.notificado
          : false
        this.form.pendencias.ajuizado.value = data.pendencias
          ? data.pendencias.ajuizado
          : false
        this.form.pendencias.cobranca.value = data.pendencias
          ? data.pendencias.cobranca
          : false
        this.form.pendencias.impeditivaAbsoluta.value = data.pendencias
          ? data.pendencias.impeditivaAbsoluta
          : false
        if (data.gerenteRelacionamento) {
          this.form.gerenteRelacionamento.value = {
            gerenteRelacionamentoId: data.gerenteRelacionamento.id,
            paId: data.gerenteRelacionamento.paId,
            nome: data.gerenteRelacionamento.pessoa.nome
          }
        }
        return this.getConversations(data.pessoa)
      } catch (error) {
        console.error(error)
      } finally {
        loading.close()
      }
    },
    openShowMessages (conversationAssociate, telefone) {
      this.conversationAssociate = conversationAssociate
      this.$refs.newConversationModal.openModal(conversationAssociate, telefone)
    },
    closeShowMessages () {
      this.$refs.newConversationModal.closeModal()
    },
    checkPendencias (person) {
      if (!person.pendencias) {
        this.hasRestrictions = false
        return
      }

      this.hasRestrictions = Object.values(person.pendencias).some(
        item => item === true
      )
    },
    onCallDependences (document) {
      this.onLoadPld(document)
      this.onLoadAllPatrimony(document)
      this.onLoadContaCorrente(document)
      this.onLoadContaCapital(document)
      this.onLoadTabPessoasEconomicGroup(document)
    },
    async onLoadAllCluster () {
      try {
        loading.push()

        const response = await ClusterRepository.GetAll()

        if (!response) return

        this.form.clusterizacaoId.options = this.onResultDropdown(
          response,
          null,
          f => f.descricao
        )
      } catch (error) {
        this.onException(error)
      } finally {
        loading.close()
      }
    },
    async onLoadAllFuncionarios () {
      try {
        loading.push()

        const response = await FuncionarioRepository.GetAll()

        if (!response) return

        this.form.gerenteRelacionamento.options = this.setDropdownGerentesRelacionamentoOptions(
          response
        )
      } catch (error) {
        this.onException(error)
      } finally {
        loading.close()
      }
    },
    onLoadPld (document) {
      this.nivelRiscoPld = null
      this.indicadorPep = null

      PldRepository.Search(document, 50, 0)
        .then(response => {
          if (response.data.content.length > 0) {
            this.nivelRiscoPld = response.data.content[0].nivelRiscoPLD
            this.indicadorPep = response.data.content[0].indicadorPep
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onLoadAllPatrimony (document) {
      loading.push()
      this.patrimony = null
      PatrimonyRepository.Search(document, 50, 0)
        .then(response => {
          if (response.data.content.length > 0) {
            this.patrimony = response.data.content
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onLoadContaCorrente (document) {
      ContaCorrenteRepository.Search(document)
        .then(response => {
          let setOfContas = new Set()
          this.contaCorrenteList = response.data.content.reduce((acc, x) => {
            if (!setOfContas.has(x.numeroContaCorrente)) {
              setOfContas.add(x.numeroContaCorrente)
              acc.push(x)
            }
            return acc
          }, [])
        })
        .catch(this.onException)
    },
    onLoadContaCapital (document) {
      ContaCapital.Search(document, 500, 0)
        .then(response => {
          let setOfContas = new Set()
          this.contaCapitalList = response.data.content.reduce((acc, x) => {
            if (!setOfContas.has(x.numContaCapital)) {
              setOfContas.add(x.numContaCapital)
              acc.push(x)
            }
            return acc
          }, [])
        })
        .catch(this.onException)
    },
    onLoadTabPessoasEconomicGroup (document) {
      loading.push()
      this.document = document
      EconomicGroupRepository.SearchPeopleIn(document, 500, 0)
        .then(response => {
          this.pessoaGrupoEconomicoList = response.data.content
        })
        .catch(err => {
          this.onException(err)
        })
      loading.close()
    },
    onClose () {
      this.$router.push({name: this.$route.params.backUrl})
    },
    async onLoadFinanceResume () {
      const document = this.objSelected.pessoa.document

      await this.onLoadContaCorrenteRepository(document)
      await this.onLoadContratosVigentesRepository(document)
      await this.onLoadCardsFromAssociate(document)

      this.isBusyInfosFinance = !this.isBusyInfosFinance
    },
    async onLoadContaCorrenteRepository (document) {
      await ContaCorrenteRepository.Search(document, 200, 0)
        .then(response => {
          const accounts = response.data.content
          this.financeResume.accounts = accounts
        })
        .catch(err => {
          console.error(err)
        })
    },
    async onLoadContratosVigentesRepository (
      document,
      productSelected,
      bacenSelected,
      subBacenSelected
    ) {
      try {
        const objFilter = {
          params: {
            modalidadeProduto: productSelected,
            submodalidadeBacen: subBacenSelected,
            modalidadeBacen: bacenSelected,
            document: document,
            page: 0,
            size: 200
          }
        }

        await ContratosVigentesRepository.Search(objFilter.params.document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(response => {
            const contracts = response.data.content
            const pageable = response.data.pageable
            this.financeResume.contracts = contracts
            this.maiorQueDezContratos = pageable.totalElements > 10
          })
          .catch(err => {
            console.error('Erro ao buscar contratos:', err)
          })
        await ContratosVigentesRepository.SearchByModalidadeProduto(
          document,
          200,
          0
        )
          .then(response => {
            this.productOptions = response.data
          })
          .catch(err => {
            console.error(
              'Erro ao buscar contratos por modalidade de produto:',
              err
            )
          })
        await ContratosVigentesRepository.SearchBySubmodalidadeBacen(
          document,
          200,
          0
        )
          .then(response => {
            this.subBacenOptions = response.data
          })
          .catch(err => {
            console.error(
              'Erro ao buscar contratos por submodalidade Bacen:',
              err
            )
          })
        await ContratosVigentesRepository.SearchByModalidadeBacen(
          document,
          200,
          0
        ).then(response => {
          this.bacenOptions = response.data
        })
      } catch (error) {
        console.error('Erro geral:', error)
      }
    },
    async onLoadCardsFromAssociate (document) {
      await CardRepository.SearchAllByDocument(document, 200, 0)
        .then(async response => {
          const cards = response.data.content
          let cardsCobranca = this.splitCardsByType(
            cards,
            this.boardTypes.COBRANCA
          )
          let cardsAjuizamento = this.splitCardsByType(
            cards,
            this.boardTypes.AJUIZAMENTO
          )

          this.financeResume.cards = {
            cobranca: cardsCobranca,
            ajuizamento: cardsAjuizamento
          }
          this.financeResume.cobrancaProducts = await this.getProdutosFromCobranca(
            cardsCobranca
          )
        })
        .catch(err => {
          console.error(err)
        })
    },
    async getProdutosFromCobranca (cards) {
      let allProducts = []

      for (const card of cards) {
        try {
          const response = await CardProductRepository.Search(card.id, 200, 0)
          const products = response.data.content
          if (products.length) allProducts.push(...products)
        } catch (err) {
          console.error(err)
        }
      }
      return allProducts
    },

    handleShowVigentes () {
      const target = document.getElementById('associateDetailsTabs')
      if (target) {
        target.scrollIntoView({behavior: 'smooth'})
      }
      this.$refs.AssociateDetailsTabs.handleShowVigentes()
    },
    setDropdownGerentesRelacionamentoOptions (response) {
      let result = []
      let data = response.data.content
      for (let i in data) {
        result.push({
          gerenteRelacionamentoId: data[i].id,
          paId: data[i].paId,
          nome: data[i].pessoa.nome
        })
      }

      return result
    },
    onFormatMoney (value) {
      let result = 'R$ 0,00'
      if (value) {
        result = Tools.formatMoneyBR(value)
      }
      return result
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    onCopyName () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.nome)
      }
    },
    onCopyDocument () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.document)
      }
    },
    onCopyNumSisbr () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.numSisbr)
      }
    },
    onCopy (value) {
      if (value) {
        var obj = this.$refs.myCopy
        obj.value = value
        obj.setAttribute('type', 'text')
        obj.select()
        document.execCommand('copy')
        toast.success(this.$lang.Common.Alerts.CopySuccess)
        obj.setAttribute('type', 'hidden')
      }
    },
    onUpdate () {
      const dataUpdate = {
        id: this.objSelected.id,
        document: this.objSelected.pessoa.document,
        numSisbr: this.objSelected.numSisbr,
        gerenteSisBRId: this.objSelected.gerenteSisBR
          ? this.objSelected.gerenteSisBR.id
          : 0,
        gerenteRelacionamentoId: this.form.gerenteRelacionamento.value
          ? this.form.gerenteRelacionamento.value.gerenteRelacionamentoId
          : 0,
        clusterizacaoId: this.form.clusterizacaoId.value || 0,
        prinome: this.form.prinome.value || null,
        enderecosId: [],
        telefonesId: [],
        tipoPessoa: this.objSelected.pessoa.tipoPessoa,
        nomeAssociado: this.objSelected.pessoa.nome,
        inicioRelacionamento: this.objSelected.inicioRelacionamento,
        ultimaRenovacao: this.objSelected.ultimaRenovacao,
        email: this.objSelected.pessoa.email,
        telefoneCelular: '',
        telefoneComercial: '',
        telefoneResidencial: '',
        rendaBrutaMensal: this.objSelected.rendaBrutaMensal,
        tipoRenda: this.objSelected.tipoRenda,
        vinculoEmpregaticio: this.objSelected.vinculoEmpregaticio,
        descricaoProfissao: this.objSelected.descricaoProfissao,
        atividadeEconomica: this.objSelected.atividadeEconomica,
        descricaoCategoria: this.objSelected.descricaoCategoria,
        dataNascimento: this.objSelected.pessoa.dataNascimento,
        observacao: this.form.observacao.value,
        pendencias: {},
        notificado: this.form.pendencias.notificado.value,
        ajuizado: this.form.pendencias.ajuizado.value,
        cobranca: this.form.pendencias.cobranca.value,
        impeditivaAbsoluta: this.form.pendencias.impeditivaAbsoluta.value
      }
      dataUpdate.enderecosId = []
      this.objSelected.pessoa.endereco.forEach(element => {
        dataUpdate.enderecosId.push(element.id)
      })

      dataUpdate.telefonesId = []
      this.objSelected.pessoa.telefone.forEach(element => {
        dataUpdate.telefonesId.push(element.id)
      })

      dataUpdate.pendencias.notificado = this.form.pendencias.notificado.value
      dataUpdate.pendencias.ajuizado = this.form.pendencias.ajuizado.value
      dataUpdate.pendencias.cobranca = this.form.pendencias.cobranca.value
      dataUpdate.pendencias.impeditivaAbsoluta = this.form.pendencias.impeditivaAbsoluta.value

      loading.push()
      AssociateRepository.Update(dataUpdate.id, dataUpdate)

        .then(() => {
          loading.close()
          this.checkPendencias(dataUpdate)
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    getPaGerenteSisbr (paIdList) {
      this.paGerenteSisbr = []
      for (let i in paIdList) {
        PARepository.GetById(paIdList[i])
          .then(res => {
            this.paGerenteSisbr.push(res.data)
          })
          .catch(this.onException)
      }
    },
    filterArray (arr) {
      let newArr = []
      arr.forEach(int => {
        if (int > 0 && !newArr.find(numb => numb === parseInt(int))) {
          newArr.push(parseInt(int))
        }
      })
      return newArr.length ? newArr : ['-']
    },
    openAssociatePage (associateId) {
      this.$router.replace({
        name: 'DetalhesAssociate',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
      // window.open(routeData.href)
      this.$router.go()
    },
    openAssociatePageByRelacionamento (document) {
      AssociateRepository.GetByDocument(document)
        .then(response => {
          response.data.content.length > 0
            ? this.openAssociatePage(response.data.content[0].id)
            : toast.error(' ATENÇÃO! Relacionamento não é um associado')
        })
        .catch(err => {
          console.error(err)
        })
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    },
    formatCep (cep) {
      var re = /^([\d]{5})([\d]{3})/
      if (re.test(cep)) {
        // eslint-disable-next-line no-useless-escape
        return cep.replace(re, '$1-$2')
      } else {
        return 'CEP inválido!'
      }
    },
    getInitialName (value) {
      return Tools.getInitialsOfName(value)
    },
    getTipoPessoa (document) {
      return Tools.checkDocumentType(document)
    },
    splitCardsByType (cards, type) {
      let cardsFromType = []
      cards.forEach(card => {
        if (card.boardColumn.board.tipoBoard === type) { cardsFromType.push(card) }
      })
      return cardsFromType
    },
    checkTrueReturnBoolean (value, debug) {
      let result

      if (!value) {
        // If value comes as Undefined or Null
        result = false
      } else if (isNaN(value)) {
        // If value comes as String
        result = value.toUpperCase() === 'SIM'
        // eslint-disable-next-line use-isnan
      } else if (parseInt(value) !== NaN) {
        // If value comes as number
        result = parseInt(value)
      } else if (typeof value === 'boolean') {
        // If value comes as boolean
        result = value
      } else {
        // Anything not mapped
        result = false
      }

      return result
    },
    formatDateTimeForms (obj) {
      return obj
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/')
    },
    toggleBusyInfosAssociado () {
      this.isBusyInfosAssociado = !this.isBusyInfosAssociado
    },
    toggleBusyGrupoEconomico () {
      this.isBusyGrupoEconomico = !this.isBusyGrupoEconomico
    },
    toggleBusyRelacionamento () {
      this.isBusyRelacionamento = !this.isBusyRelacionamento
    },
    toggleBusyLogradouro () {
      this.isBusyLogradouro = !this.isBusyLogradouro
    },
    toggleBusyContato () {
      this.isBusyContato = !this.isBusyContato
    },
    toggleMoneyBlur () {
      this.moneyBlur = !this.moneyBlur
    },
    toggleAtendimento () {
      this.isAtendimento = !this.isAtendimento
    },
    openConversation (contact) {
      this.$router.push({
        name: 'Atendimento',
        params: {
          newConversation: {
            nome: this.objSelected.pessoa.nome,
            numero: contact.telefone
          }
        }
      })
    },
    toastInfo () {
      toast.info(
        'Esta funcionalidade ainda não está disponível no seu nxCoop.'
      )
    },
    async getConversations (person) {
      this.isLoading = true
      this.conversationIsNull = false
      this.personTelefone = '55' + person.telefone.filter(t => t.tipoContato === 'CELULAR')[0].telefone.replace(/\D/g, '')

      const requestConfig = {
        status: 'Finalizado',
        identifier: this.personTelefone
      }

      try {
        loading.push()
        const response = await AtendimentoRepository.GetConversations(requestConfig)
        const { status, data } = response

        if (status === 200) {
          this.allConversations = data
          this.conversationIsNull = this.currentPageConversations.length === 0
        } else {
          this.conversationIsNull = true
        }
      } catch (error) {
        console.error(error)
        this.conversationIsNull = true
      } finally {
        this.isLoading = false
        loading.close()
      }
    }
  }
}
</script>
<style lang="scss">
  .associate-modal {
    position: absolute;
    top: 50%;
    right: 30%;
    transform: translate(-50%, -50%);
    z-index: 4;
  }
  .tabsScroll {
    div {
      ul {
        overflow-x: overlay;
        flex-wrap: nowrap;
      }
    }
  }
  // associate__info__rows__group
  .associate__info__rows {
    &__container {
      margin: 1rem 0 2.5rem 0;
    }

    &__group {
      margin-bottom: 1.75rem;

      &__title {
        font-size: 1.15rem;
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0.25rem;
      }
    }
  }

  .row {
    p {
      margin: 0;
    }

    &__container {
      display: flex;
      justify-content: space-between;
      gap: 2rem;
      padding: 8px 0;
      border-bottom: solid 1px #d9d9d9;
    }

    &__type {
      text-transform: capitalize;
    }

    &__description {
      text-transform: capitalize;
      font-weight: 600;
      text-align: justify;
    }

    &__item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }

  .money__blur {
    filter: blur(3px);
  }

  .notification__modal__header {
    background-color: #ffa500 !important;
    background-color: #ff0000 !important;
  }

  #notificationModal {
    p {
      font-size: 1rem;
    }

    .btn {
      color: #fff;
      background-color: #04a791 !important;
    }
  }
</style>

<style scoped>
  td {
    padding: 0 15px;
  }

  ul {
    list-style: none outside none;
    margin: 0;
    padding: 0;
  }

  li {
    float: left;
    margin: 0 30px;
  }

  .title-tab-configuration {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: left;
    color: #5d626c;
  }

  .title-tab-configuration a {
    text-decoration: underline;
    color: #04a791;
  }

  .close-card {
    text-align: right;
    display: block;
    right: 10px;
    position: absolute;
    top: 10px;
    z-index: 999;
  }

  card-header .nav.nav-tabs .nav-link,
  .card-header .nav.nav-tabs .navbar .dropdown-toggle,
  .navbar .card-header .nav.nav-tabs .dropdown-toggle {
    padding: 0.75rem 0.625rem;
    color: #04a791;
    border-top: 0;
  }

  .accordion > .card > .card-header {
    border-radius: 0;
    margin-bottom: 0px;
  }

  .p-1 {
    padding: 0.85rem !important;
  }

  @media (min-width: 576px) {
    .w-sm-50 {
      width: 75% !important;
    }
  }
  .position-tag {
    position: relative;
    display: inline-block;
    padding-top: 8px;
  }
  .tag {
    display: inline-block;
    background-color: #04a791;
    color: white;
    border-radius: 4px;
    padding: 5px 10px;
    margin-right: 8px;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1;
  }

  .remove-button {
    background: none;
    border: none;
    color: white;
    font-size: 12px;
    cursor: pointer;
    margin-left: 5px;
  }

  .remove-button:hover {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/associatedetails.vue